export const DAIRY_FEED_ENERGY_UNIT = {
  MJNEL: "mj_nel_per_kg_dm",
  MJME: "mj_me_per_kg_dm",
} as const;

export type ENUM_DAIRY_FEED_ENERGY_UNIT = (typeof DAIRY_FEED_ENERGY_UNIT)[keyof typeof DAIRY_FEED_ENERGY_UNIT];

export interface DairyCowType {
  id: string;
  translationSlug: string;
  enabled: boolean;
}

export type DairyFeedAdditive = {
  id: string;
  enabled: boolean;
  translationSlug: string;
};

export type DairyManureStorage = {
  id: string;
  enabled: boolean;
  translationSlug: string;
};

export interface DairyFeedType {
  id: string;
  translationSlug: string;
  enabled: boolean;
  energyMjMeKgDm: number | null;
  energyMjNelKgDm: number | null;
  mjMeToMjNel: number | null;
  dryMatterPerFeedTypePct: number;
  ndfPct: number;
  isSilage: boolean;
  // True for the reserved "Custom Feed" catalog row, whose energy, dry matter and emission
  // factor are entered per feed-information row rather than looked up here
  isCustom: boolean;
}
